import React from "react"
import PropTypes from "prop-types"
import Font from "@cred/react-font"

const Icon = ({
  icon,
  className
}) => {
  if (typeof icon === 'string' && icon.startsWith('icon-')) {
    return <Font element="i" type="medium" className={`cred-icon ${icon} ${className}`} data-testid="customRadioIcon"/>
  } else {
    return <div className={className} data-testid="customRadioIcon">{icon}</div>
  }
}

Icon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default Icon
